import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';

import { 
  Tooltip, 
  List, 
  Table, 
  Button, 
  Spin, 
  message 
} from 'antd';

import { 
  StyledListItem, 
  StyledListItemTitleContainer, 
  StyledListItemTitle, 
  StyledAppointmentsCount 
} from './styled';

import { pluralize } from './pluralize';
import { lookUpDetails } from "../../api/LookUpAPI";

const Logo = ({ client }) => {
  const [logo, setLogo] = useState({
    loading: true,
    src: null,
    name: null
  })

  const handleImageError = () => {
    setLogo(prev => ({ ...prev, src: null }))
  };

  useEffect(() => {
    if (client?._id) {
      lookUpDetails("client", client._id)
        .then((res) => {
          if (res.data && res.data.payload) {
            const { logoImage } = res.data.payload;
            setLogo({
              loading: false,
              src: logoImage,
              name: client.name
            })
          }
        });
    }
  }, [client])

  if (logo.loading) return <Spin />
  if (logo.src) return <img onError={handleImageError} src={logo.src} width={80}/>
  if (logo.name) return logo.name
  return null
}


const AppointmentsTable = ({ consultations }) => {
  const history = useHistory();
  const handleCopy = async (e, link) => {
    e.stopPropagation()
    await navigator.clipboard.writeText(link);
    message.info('Link copied to clipboard');
  }

  const columns = [
    {
      key: 'startTime',
      render: ({ startTime, physician }) => (
        <Tooltip title={dayjs(startTime).tz(physician?.availability?.preferredIANATimeZoneName || dayjs.tz.guess()).format('hh:mmA (z)')}>
            {dayjs(startTime).tz(dayjs.tz.guess()).format('hh:mmA (z)').toString()}
        </Tooltip>
      ),
      width: 150
    },
    {
      dataIndex: 'case',
      key: 'logo',
      render: ({ client }) => <Logo client={client} />,
      width: 100
    },
    {
      dataIndex: 'patient',
      key: 'patient',
      render: ({ firstName, lastName }) => `${firstName} ${lastName}`,
    },
    {
      dataIndex: 'case',
      key: 'state',
      render: ({ stateObj }) => stateObj?.name,
    },
    {
      key: 'meeting',
      render: ({ meeting, physician }) => {
        const link = meeting?.link || physician?.meetingLink;
        if (link) return <Tooltip title={link}><Button onClick={(e) => handleCopy(e, link)}>Zoom</Button></Tooltip>
        return null
      }
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={consultations}
      showHeader={false}
      onRow={record => ({
        onClick: () => {
          history.push(`/cases/${record.case._id}`)
        }
      })}
      pagination={{
        pageSize: 3,
      }}
    />
  )
}

export const ConsultationsList = ({ physicians }) => (
  <List>
    {
      physicians.map((physician, indx) => (
        <StyledListItem underline={indx < physicians.length - 1} onClick={() => setSelectedPhysician(physician)}>
          <List.Item.Meta
            title={
              <StyledListItemTitleContainer>
                <StyledListItemTitle>{physician.firstName} {physician.lastName}</StyledListItemTitle>
                <StyledAppointmentsCount>{physician.consultations.length} {pluralize('appt', physician.consultations.length)}</StyledAppointmentsCount>
              </StyledListItemTitleContainer>
            }
            description={<AppointmentsTable consultations={physician.consultations} />}
          />
        </StyledListItem>
      ))
    }
  </List>
)